import React from 'react';
import classes from "./CategorySection.module.css";
import { useNavigate } from 'react-router-dom';

const CategorySection = ({ categories }) => {
    const navigate=useNavigate();
    return (
        // <section className={classes.games_category_section}>
        <div className={classes.games_grid_container}>
            {categories.map((item, index) => {
                if (index > 0 && item?.id>0) {
                    return (
                        <div
                            key={index}
                            className={`${classes.game_grid_item} ${index === 2 ? classes.featured : ""
                                }`}
                            onClick={() => navigate("/category", {
                                state: {
                                    category_id: item?.id
                                }
                            })}
                        >
                            <img
                                src={item.category_img}
                                loading='lazy'
                                alt={item.category_name}
                                className={classes.game_grid_item_image}
                                style={{
                                    filter: (item?.category_name === 'Mind' || item?.category_img?.includes('mind'))
                                        ? 'hue-rotate(200deg)'
                                        : 'none'
                                }}
                            />

                            {/* <div className={classes.game_grid_overlay}>
                                <span>{item.category_name}</span>
                            </div> */}
                        </div>
                    )
                }
            }
            )}
        </div>
        // </section>
    )
}

export default CategorySection